import * as React from 'react';

import { Box } from '@lightspeed/flame/Core';

import { downloadImportTemplateURL } from '../../utils/helper-url';

const ImportTemplate: React.FC = () => {
  const systemCustomerId = window.merchantos.session.getSystemCustomerID();
  return (
    <Box pt={2} pl={2} pr={2}>
      View sample file{' '}
      <a
        href={systemCustomerId ? downloadImportTemplateURL(systemCustomerId) : ''}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        download template
      </a>
    </Box>
  );
};

export default ImportTemplate;
